(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reevys-announcement"] && !Shopify.designMode) return;
  try {
    
  class ReevysAnnouncement extends HTMLElement {
    connectedCallback() {
      this.storageKey = `reevys:announcement:${this.dataset.key}`;
      try {
        if (this.dataset.designMode !== 'true' && sessionStorage.getItem(this.storageKey) === 'closed') this.hidden = true;
      } catch {}
      this.querySelector('button')?.addEventListener('click', this.dismiss);
    }
    disconnectedCallback() { this.querySelector('button')?.removeEventListener('click', this.dismiss); }
    dismiss = () => {
      this.hidden = true;
      try { sessionStorage.setItem(this.storageKey, 'closed'); } catch {}
      document.querySelector('#header-component .header-logo a, #header-component a.header-logo')?.focus({ preventScroll: true });
      window.dispatchEvent(new Event('resize'));
    };
  }
  if (!customElements.get('reevys-announcement')) customElements.define('reevys-announcement', ReevysAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reevys-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  class ReevysHeroMedia extends HTMLElement {
    #controller;
    #observer;
    #viewport = matchMedia('(max-width: 749px)');
    #motion = matchMedia('(prefers-reduced-motion: reduce)');
    #video;
    #key;
    #visible = true;
    #userPaused = false;

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.#viewport.addEventListener('change', this.#syncMedia, { signal });
      this.#motion.addEventListener('change', this.#syncPlayback, { signal });
      document.addEventListener('visibilitychange', this.#syncPlayback, { signal });
      this.querySelector('button').addEventListener('click', this.#togglePlayback, { signal });
      this.#observer = new IntersectionObserver(([entry]) => {
        this.#visible = entry.isIntersecting;
        this.#syncPlayback();
      });
      this.#observer.observe(this);
      this.#syncMedia();
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.#observer.disconnect();
      this.#video?.pause();
      this.#key = undefined;
    }

    #syncMedia = () => {
      const key = this.#viewport.matches ? this.dataset.mobileVideo : this.dataset.desktopVideo;
      if (key === this.#key) return;
      this.#key = key;
      this.#video?.pause();
      const mount = this.querySelector('.reevys-hero__video-mount');
      mount.replaceChildren();
      const template = key && this.querySelector(`template[data-hero-video="${key}"]`);
      if (template) mount.append(template.content.cloneNode(true));
      this.#video = mount.querySelector('video');
      this.querySelector('button').hidden = !this.#video;
      if (!this.#video) return;
      this.#video.muted = true;
      this.#video.addEventListener('play', this.#syncButton);
      this.#video.addEventListener('pause', this.#syncButton);
      this.#syncPlayback();
      this.#syncButton();
    };

    #syncPlayback = () => {
      if (!this.#video) return;
      if (this.#visible && !document.hidden && !this.#motion.matches && !this.#userPaused) {
        this.#video.play().catch(() => this.#syncButton());
      } else this.#video.pause();
    };

    #togglePlayback = () => {
      if (!this.#video) return;
      this.#userPaused = !this.#video.paused;
      if (this.#userPaused) this.#video.pause();
      else this.#video.play().catch(() => this.#syncButton());
    };

    #syncButton = () => {
      const paused = !this.#video || this.#video.paused;
      const button = this.querySelector('button');
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.title = button.getAttribute('aria-label');
      button.querySelector('[data-play-icon]').hidden = !paused;
      button.querySelector('[data-pause-icon]').hidden = paused;
    };
  }
  if (!customElements.get('reevys-hero-media')) customElements.define('reevys-hero-media', ReevysHeroMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reevys-global-styles"]) return;
  try {
    
  const reevysRoot = document.documentElement;

  document.addEventListener(
    'pointerdown',
    () => {
      reevysRoot.dataset.reevysInput = 'pointer';
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Tab' ||
        event.key === 'Enter' ||
        event.key === ' ' ||
        event.key.startsWith('Arrow')
      ) {
        reevysRoot.dataset.reevysInput = 'keyboard';
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
